module.exports = __webpack_public_path__ + "static/media/20211015.3d9f0962.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/banner/20211015/img/20211015.png
// module id = 308
// module chunks = 0